
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business-form",
      function () {
        return require("private-next-pages/business-form.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business-form"])
      });
    }
  